import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';

import Loading from '../../components/Loading';
import { statusesPath } from '../../utils/firebasePaths';
import StatusListItem from '../StatusListItem';

const { dataToJS } = helpers;

@fb(({ channelId, teamId }) => [
  `${statusesPath({ channelId, teamId })}#limitToLast=100`
])
@connect(
  ({ firebase }, { channelId, teamId }) => ({
    statuses: dataToJS(firebase, statusesPath({ channelId, teamId })),
  })
)
export default class Statuses extends Component {
  static propTypes = {
    channelId: PropTypes.string.isRequired,
    statuses: PropTypes.object,
    teamId: PropTypes.string.isRequired,
  }

  render() {
    const { channelId, statuses, teamId } = this.props;

    if (!statuses) {
      return <Loading />;
    }

    const statusKeys = Object.keys(statuses).sort();

    return (
      <ul className="list pl0">
        {
          statusKeys.reverse().map((key, index) => (
            <StatusListItem
              canShowEdit={index === 0}
              channelId={channelId}
              key={key}
              status={{ ...statuses[key], id: key }}
              teamId={teamId}
              type={index === 0 ? 'large' : 'image'}
            />
          ))
        }
      </ul>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/Statuses/index.jsx
 **/